import { CheckIcon, CopyIcon } from "@chakra-ui/icons";
import { Button, HStack, Text } from "@chakra-ui/react";
import { getShortContractAddress } from "@syla/shared/helpers/assets/getShortContractAddress";
import React from "react";
import create from "zustand";
import { useClipboardToast } from "../../../../hooks/useClipboardToast";

export function AddressDisplay({ addresses }: { addresses: string[] }) {
  // we can have multiple addresses provided/stored on the transaction, but
  // we currently only ever display the first one.
  const address = addresses[0];

  const { onCopy, hasCopied } = useClipboardToast({
    value: address,
    toastOptions: {
      title: "Copied address",
    },
  });

  const { selectedAddress } = useSameAddressStore();

  if (!address) {
    return null;
  }

  const isSelected = address === selectedAddress;

  const CopyStatusIcon = hasCopied ? CheckIcon : CopyIcon;

  return (
    <Button
      fontWeight="light"
      fontSize="sm"
      variant="ghost"
      role="group"
      onClick={(event) => {
        event.stopPropagation();
        onCopy();

        event.currentTarget.blur();
      }}
      height="fit-content"
      width="fit-content"
      px={1}
      py={1}
      color={isSelected ? "primary.700" : "gray.600"}
      backgroundColor={isSelected ? "primary.25" : "transparent"}
      alignItems="flex-start"
      onMouseEnter={() => {
        useSameAddressStore.setState({
          selectedAddress: address,
        });
      }}
      onMouseLeave={() => {
        useSameAddressStore.setState({
          selectedAddress: undefined,
        });
      }}
    >
      <HStack spacing={1} align="center">
        <Text>{getShortContractAddress(address)}</Text>

        <CopyStatusIcon
          boxSize={3}
          visibility="hidden"
          _groupHover={{
            visibility: "visible",
          }}
        />
      </HStack>
    </Button>
  );
}

// use a common store to highlight all addresses that match the current mouse over
export type SameAddressStore = {
  selectedAddress: string | undefined;
};

const useSameAddressStore = create<SameAddressStore>(() => ({
  selectedAddress: undefined,
}));
